module.exports = __webpack_public_path__ + "img/logo-full-competti-big.81872b88.png";